import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from '@material-ui/core/styles';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { BorderBottom } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../../store/store';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { openChatWoot } from '../../../store/reducers/openChatWootSlice';
import moment from 'moment';

const useStyles = makeStyles({
 container: {
  display: 'flex',
  flexDirection: 'column',
  border: '1px #FFB614 solid',
  padding: '20px',
  marginLeft: '80px',
  marginRight: '80px',
  marginTop: '60px',
  width: 'calc(100% - 160px)',
  cursor: 'default',
  height: 'calc(100% + 10px)',

  '& .MuiAccordion': {
   display: 'none !important',
   borderBottom: 'none !important',
   bottom: 'none !important',
  },
 },
});

const Documents = () => {
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();

 const [expanded, setExpanded] = useState<number>(null);
 const [tokenValue, setTokenValue] = useState<string>('vostok');

 /**
  * Добавил список всех подразделений. В будузем просто добавлять в список.
  */
 useEffect(() => {
  const tokens = [
   'vostok',
   'eric',
   'ricso',
   'yritz',
   'yugra',
   'ntesk',
   'nesko',
   'yutec',
  ];
  const currentUrl = window.location.href;

  const matchedToken = tokens.find((token) => currentUrl.includes(token));
  if (matchedToken) {
   setTokenValue(matchedToken);
  }
 }, []);

 // Custom handler that accepts the id first
 const handleChange = (id) => (event, isExpanded) => {
  if (id === 2 || id === 3) {
   setExpanded(isExpanded ? id : 1);
  } else {
   setExpanded(isExpanded ? id : false);
  }
 };

 const handleOpenChatWoot = (e: any) => {
  dispatch(openChatWoot(moment()));
 };

 return (
  <div style={{ zIndex: 1000000 }}>
   <Card className={classes.container}>
    <CardActionArea sx={{ cursor: 'default' }}>
     <CardContent>
      <Typography
       variant="body2"
       sx={{ color: 'text.secondary', cursor: 'default', marginBottom: '20px' }}
      >
       <Accordion
        disableGutters={false}
        elevation={0}
        sx={{ '&:before': { display: 'none' } }}
        expanded={expanded === 0}
        onChange={handleChange(0)}
        style={{
         width: '100%',
         marginTop: '20px',
         fontSize: '22px',
         border: 'none !important',
        }}
       >
        <AccordionSummary
         style={{ padding: 0 }}
         expandIcon={
          <ArrowForwardIosSharpIcon
           style={{ width: '14px', height: '14px', fontWeight: 800 }}
          />
         }
         aria-controls="panel1a-content"
         //className={classes.accordionSummary}
         id="panel1a-header"
         sx={{
          flexShrink: '0',
         }}
        >
         <label style={{ fontWeight: 800, cursor: 'pointer' }}>
          ЭЭ ТЭ ГВС ХВС
         </label>
        </AccordionSummary>

        <AccordionDetails
         style={{ padding: 0, margin: 0, maxHeight: 'auto' }}
         //className={classes.accordionDetail}
        >
         <div
          style={{
           display: 'flex',
           flexDirection: 'column',
           height: '120px',
          }}
         >
          <a
           href="../../../documentsByRegion/Приложение № 1. Форма заявки для ЮЛ.docx"
           target="_blank"
          >
           <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
           <label
            style={{
             fontStyle: 'italic',
             cursor: 'pointer',
             paddingBottom: '20px',
             position: 'absolute',
             fontSize: '18px',
            }}
           >
            Приложение № 1. Форма заявки для ЮЛ
           </label>
          </a>
          <a
           href="../../../documentsByRegion/Приложение № 2. Форма заявки для ФЛ-ИП.docx"
           target="_blank"
          >
           <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
           <label
            style={{
             fontStyle: 'italic',
             cursor: 'pointer',
             paddingBottom: '20px',
             position: 'absolute',
             fontSize: '18px',
            }}
           >
            Приложение № 2. Форма заявки для ФЛ-ИП
           </label>
          </a>
          <a
           href="../../../documentsByRegion/Приложение № 3. Форма заявки для ИКУ.docx"
           target="_blank"
          >
           <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
           <label
            style={{
             fontStyle: 'italic',
             cursor: 'pointer',
             paddingBottom: '20px',
             position: 'absolute',
             fontSize: '18px',
            }}
           >
            Приложение № 3. Форма заявки для ИКУ
           </label>
          </a>
         </div>
        </AccordionDetails>
       </Accordion>

       {tokenValue === 'vostok' && (
        <React.Fragment>
         <Accordion
          disableGutters={true}
          elevation={0}
          sx={{ '&:before': { display: 'none' } }}
          expanded={expanded === 1 || expanded === 2 || expanded === 3}
          onChange={handleChange(1)}
          style={{
           width: '100%',
           fontSize: '22px',
           border: 'none !important',
          }}
         >
          <AccordionSummary
           style={{ padding: 0 }}
           expandIcon={
            <ArrowForwardIosSharpIcon
             style={{ width: '14px', height: '14px', fontWeight: 800 }}
            />
           }
           aria-controls="panel1a-content"
           //className={classes.accordionSummary}
           id="panel1a-header"
           sx={{
            flexShrink: '0',
           }}
          >
           <label style={{ fontWeight: 800, cursor: 'pointer' }}>ТКО</label>
          </AccordionSummary>

          <AccordionDetails
           style={{ padding: 0, margin: 0, maxHeight: 'auto' }}
           //className={classes.accordionDetail}
          >
           <div style={{ height: '200px' }}>
            <div
             style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '40px',
             }}
            >
             <Accordion
              disableGutters={true}
              elevation={0}
              sx={{ '&:before': { display: 'none' } }}
              expanded={expanded === 2}
              onChange={handleChange(2)}
              style={{
               width: '100%',
               fontSize: '22px',
               border: 'none !important',
              }}
             >
              <AccordionSummary
               style={{ padding: 0 }}
               expandIcon={
                <ArrowForwardIosSharpIcon
                 style={{ width: '14px', height: '14px', fontWeight: 800 }}
                />
               }
               aria-controls="panel1a-content"
               //className={classes.accordionSummary}
               id="panel1a-header"
               sx={{
                flexShrink: '0',
               }}
              >
               <label style={{ fontWeight: 800, cursor: 'pointer' }}>
                Тюменская область
               </label>
              </AccordionSummary>

              <AccordionDetails
               style={{ padding: 0, margin: 0, maxHeight: 'auto' }}
               //className={classes.accordionDetail}
              >
               <div style={{ height: '200px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                 <a
                  href="../../../documentsByRegion/Перечень документов для заключения договоров на оказание услуг по обращению с твердыми коммунальными отходами.docx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Перечень документов для заключения договоров на оказание
                   услуг по обращению с твердыми коммунальными отходами
                  </label>
                 </a>

                 <a
                  href="../../../documentsByRegion/tyumen/Заявка на заключение договора по обращению с ТКО с региональным оператором для ФЛ и ИП.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Заявка на заключение договора по обращению с ТКО с
                   региональным оператором для ФЛ и ИП
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/tyumen/Заявка на заключение договора по обращению с ТКО с региональным оператором для ЮЛ.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Заявка на заключение договора по обращению с ТКО с
                   региональным оператором для ЮЛ
                  </label>
                 </a>

                 <a
                  href="../../../documentsByRegion/tyumen/Заявка на заключение договора по обращению с ТКО с региональным оператором для СНТ и ГСК.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Заявка на заключение договора по обращению с ТКО с
                   региональным оператором для СНТ и ГСК
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/tyumen/Схема.docx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Схема
                  </label>
                 </a>
                </div>
               </div>
              </AccordionDetails>
             </Accordion>

             <Accordion
              disableGutters={true}
              elevation={0}
              sx={{ '&:before': { display: 'none' } }}
              expanded={expanded === 3}
              onChange={handleChange(3)}
              style={{
               width: '100%',
               fontSize: '22px',
               border: 'none !important',
              }}
             >
              <AccordionSummary
               style={{ padding: 0 }}
               expandIcon={
                <ArrowForwardIosSharpIcon
                 style={{ width: '14px', height: '14px', fontWeight: 800 }}
                />
               }
               aria-controls="panel1a-content"
               //className={classes.accordionSummary}
               id="panel1a-header"
               sx={{
                flexShrink: '0',
               }}
              >
               <label style={{ fontWeight: 800, cursor: 'pointer' }}>
                Курганская область
               </label>
              </AccordionSummary>

              <AccordionDetails
               style={{ padding: 0, margin: 0, maxHeight: 'auto' }}
               //className={classes.accordionDetail}
              >
               <div style={{ height: '200px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                 <a
                  href="../../../documentsByRegion/Перечень документов для заключения договоров на оказание услуг по обращению с твердыми коммунальными отходами.docx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Перечень документов для заключения договоров на оказание
                   услуг по обращению с твердыми коммунальными отходами
                  </label>
                 </a>

                 <a
                  href="../../../documentsByRegion/kurgan/Форма заявки на заключение договора по обращению с ТКО с региональным оператором для ЮЛ.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Форма заявки на заключение договора по обращению с ТКО с
                   региональным оператором для ЮЛ
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/kurgan/Форма заявки на заключение договора по обращению с ТКО с региональным оператором для ФЛ и ИП.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Форма заявки на заключение договора по обращению с ТКО с
                   региональным оператором для ФЛ и ИП
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/kurgan/Форма заявки на заключение договора по обращению с ТКО с региональным оператором для СНТ и ГСК.xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Форма заявки на заключение договора по обращению с ТКО с
                   региональным оператором для СНТ и ГСК
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/kurgan/Форма заявки на заключение договора по обращению с ТКО с региональным оператором для ИКУ (ТСЖ, УК, ЖСК и т.п.).xlsx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Форма заявки на заключение договора по обращению с ТКО с
                   региональным оператором для ИКУ (ТСЖ, УК, ЖСК и т.п.)
                  </label>
                 </a>
                 <a
                  href="../../../documentsByRegion/kurgan/Схема.docx"
                  target="_blank"
                 >
                  <SimCardDownloadIcon
                   sx={{ marginRight: '5px', color: '#FFB614' }}
                  />
                  <label
                   style={{
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    paddingBottom: '20px',
                    position: 'absolute',
                    fontSize: '18px',
                   }}
                  >
                   Схема
                  </label>
                 </a>
                </div>
               </div>
              </AccordionDetails>
             </Accordion>
            </div>
           </div>
          </AccordionDetails>
         </Accordion>
        </React.Fragment>
       )}

       {/* Нажмите на ссылку, чтобы скачать документ
       <br /> */}
       {/* <div
        style={{
         marginTop: '20px',
         fontWeight: 800,
         display: 'flex',
         flexDirection: 'column',
        }}
       > */}
       {/* <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../documents/Приказ о внесении изменений  об утверждении форм заявлений потребителей 2026.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           Приказ о внесении изменений об утверждении форм заявлений
           потребителей 2026
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../documents/приложение № 1. форма заявки для юл.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           приложение № 1. форма заявки для юл
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../documents/приложение № 2. форма заявки для фл-ип.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           приложение № 2. форма заявки для фл-ип
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../documents/приложение № 3. форма заявки для ику.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           приложение № 3. форма заявки для ику
          </label>
         </a>
        </div> */}
       {/* </div> */}
      </Typography>
     </CardContent>
    </CardActionArea>
   </Card>
   <div style={{ marginTop: '10px', marginLeft: '80px' }}>
    Подать документы на заключение или перезаключение договора можно через
    {
     <a href="#" onClick={handleOpenChatWoot}>
      <label
       style={{
        cursor: 'pointer',
        fontWeight: 800,
        color: '#0066cc',
        textDecoration: 'underline',
        marginLeft: '5px',
       }}
      >
       Онлайн ЦОК
      </label>
     </a>
    }
   </div>
  </div>
 );
};

export default Documents;
